module.exports = __webpack_public_path__ + "static/media/npsScore.28f7837f.png";